import constants from './constants';
import axios from 'axios'

export function AddOrUpdateGridHeaders(nodeId, selectedItemGrid, successCallback, errorCallback)
{
    let gridData = new FormData();
    gridData.append('gridData',JSON.stringify(selectedItemGrid));

    window.showLoading();
    axios.post(`${constants.baseApiUrl}Document/AddOrUpdateGridHeaders?nodeId=${nodeId}`, gridData)
        .then((res) => successCallback(res))
        .catch((err) =>
        {
            console.warn(err)
            if (errorCallback != null && errorCallback != undefined)
                errorCallback(err)
        })
        .finally(() => window.hideLoading())
}

export function DoesDocumentHavePendingSignatures(documentId, successCallback, errorCallback)
{
    axios.get(`${constants.baseApiUrl}Document/DoesDocumentHavePendingSignatures?documentId=${documentId}`)
        .then(res => {
            var response = res.data
            successCallback(response)
        })
        .catch((err) => 
        {
            console.warn(err)
            if (errorCallback != null && errorCallback != undefined)
                errorCallback(err)
        })
        .finally(() => window.hideLoading())
}
